import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { listDocumentChildren, type DocumentChildrenResponse } from '../api';
import { reviewerQueryKeys } from './useDocumentResult';

/**
 * Lists the child sub-documents of a split parent. The reviewer page enables this only once the
 * status poll reports the terminal `split` state, so an ordinary job never triggers the call.
 */
export function useDocumentChildren(
  jobId: string,
  options: { enabled?: boolean } = {},
): UseQueryResult<DocumentChildrenResponse> {
  return useQuery({
    queryKey: reviewerQueryKeys.children(jobId),
    queryFn: ({ signal }) => listDocumentChildren(jobId, signal),
    enabled: (options.enabled ?? true) && jobId.length > 0,
    // The split is immutable once the parent is terminal; cache for a while.
    staleTime: 30_000,
    gcTime: 5 * 60_000,
    retry: 1,
  });
}
